import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 14, viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.4844 7.98438H8.48438V13.9844H6.51562V7.98438H0.515625V6.01562H6.51562V0.015625H8.48438V6.01562H14.4844V7.98438Z", fill: "white" }));
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
